import { ServiceWithRFQID } from '@/services/Service'
const ENDPOINTS = {
  GET: 'RFQ1s/Get',
  GET_DYNAMIC: 'RFQ1s/GetAllDynamic',
  POST: 'RFQ1s/Create',
  PATCH: 'RFQ1s/Patch',
  PUT: 'RFQ1s/Put',
  DELETE: 'RFQ1s/Delete'
}

class ModuleServiceRFQ1s extends ServiceWithRFQID {
}
export const ServiceRFQ1s = new ModuleServiceRFQ1s({
  apiGet: ENDPOINTS.GET,
  apiGetDynamic: ENDPOINTS.GET_DYNAMIC,
  apiPost: ENDPOINTS.POST,
  apiPatch: ENDPOINTS.PATCH,
  apiPut: ENDPOINTS.PUT,
  apiDelete: ENDPOINTS.DELETE
})
